import React from 'react';
import * as css from 'styles'
import styled from 'react-emotion'
import slugify from 'utils/slugify'


import View from 'components/View/View';
// import Button from 'components/Button/Button';
// import Text from 'components/Text/Text';
// import FadeIn from '../components/Animated/FadeIn';
// import Link from '../components/Link/Link';
import Img from '../components/Img/Img'
import { Grid, Col } from 'components/Grid'

const ImageRow = styled(View)({
  marginBottom: css.space.xxl,
});

const SingleImage = ({ data }) => (
  <ImageRow>
    <Img src={data.image.url} width={data.image.width} height={data.image.height} nospinner />
  </ImageRow>
)

const DoubleImage = ({ data }) => (
  <ImageRow>
  <Grid gutter="4em">
    <Col>
      <Img src={data.image_left.url} width={data.image_left.width} height={data.image_left.height} nospinner />
    </Col>
    <Col>
      <Img src={data.image_right.url} width={data.image_right.width} height={data.image_right.height} nospinner />
    </Col>
  </Grid>
  </ImageRow>
)

class Layout extends React.Component {

  renderSection = (section, i) => {
    // Simple Object to switch which section component is needed from 'acf_fc_layout'
    const sections = {
      'single_image': <SingleImage key={i} data={section} />,
      'double_image': <DoubleImage key={i} data={section} />,
      // 'text_section': <SectionText key={i} data={section} />,
      // 'images_section': <SectionImageSlider key={i} data={section} />,
      // 'video_section': <SectionVideo key={i} data={section} />,
      // 'featured_events': <SectionFeaturedEvents key={i} data={section} events={this.props.events} />,
      // 'list_events': <SectionListEvents key={i} data={section} events={this.props.events} />,
      // 'divider': <SectionDivider key={i} data={section} />,
      // 'button': <SectionButton key={i} data={section} />,
    }
    const anchor = (section.section_name) ? slugify(section.section_name) : ''
    return (
      <div key={i} id={anchor}>
        {sections[section['acf_fc_layout']]}
      </div>
    )
  }

  render() {
    const layout = this.props.blocks.map((section, i) => this.renderSection(section, i))

    console.log(this.props.blocks);

    return (
      <View>{layout}</View>
    )
  }
}

export default Layout;




// WEBPACK FOOTER //
// ./src/containers/Layout.js